import axios from 'axios';

export const voidedDocApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-voided-document/`,
    headers: {
        'Content-Type': 'application/json'
    }
})